// @flow
import SimpleDate from 'app/common/classes/simple-date';

export default SimpleDate;
